import React, { useImperativeHandle, useState } from 'react';
import { Checkbox } from 'antd';
import { uuid } from '@/utils';
import styles from './index.module.scss';

interface RoomInfoCardProps {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  cardList: Array<{
    style?: React.CSSProperties;
    keyItemList: Array<{
      label: string;
      key: string;
      render?: (val, record) => any;
      style?: React.CSSProperties;
      labelStyle?: React.CSSProperties;
    }>;
  }>;
  record: any;
  showRowSelection?: boolean;
  checked?: boolean;
  onChange?: (value: boolean, record: any) => void;
}

const RoomInfoCard = React.forwardRef<any, RoomInfoCardProps>(
  (
    { title, extra, cardList, record, showRowSelection = false, checked = false, onChange },
    ref,
  ) => {
    const handleChange = (e) => {
      if (onChange) {
        onChange(e.target.checked, record);
      }
    };

    useImperativeHandle(ref, () => ({}), []);

    return (
      <>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              {showRowSelection ? (
                <Checkbox checked={checked} onChange={handleChange} style={{ marginRight: 12 }} />
              ) : null}
              {title}
            </div>
            <div className={styles.extra}>{extra}</div>
          </div>
          <div className={styles.content} style={{ paddingLeft: showRowSelection ? 40 : 12 }}>
            {cardList?.map((item) => (
              <div className={styles.column} key={uuid()} style={item.style}>
                {item?.keyItemList?.map((keyItem) => (
                  <div className={styles.showItem} key={keyItem.key} style={keyItem.style}>
                    <div className={styles.label} style={keyItem.labelStyle}>
                      {keyItem.label}
                    </div>
                    <div className={styles.value}>
                      {typeof keyItem.render === 'function'
                        ? keyItem.render(record?.[keyItem.key], record)
                        : record?.[keyItem.key]}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  },
);

export default RoomInfoCard;
